import { Colors } from '@chakra-ui/react';

const colors: Colors = {};

export default colors;
